import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageSurfaceHeaderComponent } from './page-surface-header/page-surface-header.component';
import { PageBodyPanelComponent } from './page-body-panel/page-body-panel.component';
import { RouterModule } from '@angular/router';
import { CardOuterComponent } from './card-outer/card-outer.component';
import { CardTitleComponent } from './card-title/card-title.component';
import { DashboardSubModuleComponent } from './dashboard-sub-module/dashboard-sub-module.component';
import { BirthdayCardComponent } from './birthday-card/birthday-card.component';
import { CardContentComponent } from './card-content/card-content.component';
import { FlatpickrModule } from 'angularx-flatpickr';
import { IconModule } from "./icon/icon.module";
import { MaterialModule } from '../material.module';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FlatpickrModule,
    IconModule,
    MaterialModule,
    PageSurfaceHeaderComponent,
    PageBodyPanelComponent,
    CardOuterComponent,
    CardTitleComponent,
    DashboardSubModuleComponent,
    BirthdayCardComponent,
    CardContentComponent,
  ],
  exports: [
    FlatpickrModule,
    PageSurfaceHeaderComponent,
    PageBodyPanelComponent,
    CardOuterComponent,
    CardTitleComponent,
    DashboardSubModuleComponent,
    BirthdayCardComponent,
    CardContentComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
